import { render, staticRenderFns } from "./TheerCyberCustomerDetail.vue?vue&type=template&id=37ba44cd&scoped=true&"
import script from "./TheerCyberCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./TheerCyberCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./TheerCyberCustomerDetail.vue?vue&type=style&index=0&id=37ba44cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba44cd",
  null
  
)

export default component.exports